var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 14",
    style: {
      enableBackground: "new 0 0 12 14"
    },
    xmlSpace: "preserve",
    width: 12,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    fill: "#FFFFFF"
  }, "\t.st0{clip-path:url(#SVGID_00000108303082356526218050000009834547173570535040_);}\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#73BE2F;}")), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "IP_ID_8a25",
    width: 12,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "IP_ID_8a25",
    width: 12,
    height: 14
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096766999609627073820000010782749086188662967_",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#IP_ID_8a25",
    style: {
      overflow: "visible"
    },
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096766999609627073820000010782749086188662967_)"
    },
    fill: "#FFFFFF"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,1.75c-0.9724598,0-1.9198098,0.42084-2.6291201,1.1946299C2.65957,3.7206099,2.25,4.7859902,2.25,5.90909 c0,0.5661898,0.2200501,1.2535501,0.6172099,2.0102c0.39149,0.7458797,0.92243,1.4980597,1.4677701,2.1777101 c0.5433598,0.6772003,1.0887399,1.2672997,1.4991698,1.6886997c0.0588603,0.0604,0.1148601,0.1173,0.1675901,0.1704006 c0.0521502-0.0522003,0.1075001-0.1081009,0.1656399-0.1674004c0.4101901-0.4187002,0.9552603-1.0054998,1.4983001-1.6803999 c0.5450001-0.6773005,1.0755901-1.4280605,1.4668398-2.17488C9.52911,7.1764302,9.75,6.4844899,9.75,5.90909 c0-1.1230998-0.4095697-2.1884801-1.1208801-2.9644601C7.9198098,2.17084,6.9724598,1.75,6,1.75z M6,13 c-0.5068598,0.5528002-0.5071101,0.5525999-0.5071101,0.5525999L5.49154,13.5513l-0.0032301-0.0029001l-0.01125-0.0103998 L5.43611,13.4996996c-0.0352201-0.033-0.0859499-0.0810995-0.1499801-0.1427994 c-0.1279998-0.1234007-0.3094401-0.3017006-0.5265298-0.5246c-0.43332-0.4449005-1.0129402-1.0717001-1.5945802-1.7966003 C2.5853601,10.3133001,1.9913,9.4780397,1.53904,8.6164198C1.09245,7.7655702,0.75,6.8253498,0.75,5.90909 c0-1.4808402,0.53864-2.91275,1.5151501-3.9780402C3.24367,0.863572,4.5855098,0.25,6,0.25 s2.7563295,0.613571,3.7348499,1.6810499C10.7114,2.99634,11.25,4.4282498,11.25,5.90909 c0,0.9231901-0.3416004,1.86689-0.7888002,2.7204304c-0.4524994,0.8637094-1.0468798,1.6983795-1.6268797,2.4191799 c-0.5819597,0.7231998-1.16189,1.3470993-1.5954499,1.7896996c-0.2172203,0.2216997-0.3987703,0.3990002-0.5268703,0.5215998 C6.6479201,13.4214001,6.5971298,13.4691,6.5618601,13.5019999L6.5208402,13.54l-0.0112801,0.0102997L6.50631,13.5532999 L6.5053,13.5542002C6.5053,13.5542002,6.5047002,13.5548,6,13z M6,13l0.5053,0.5542002 c-0.2869601,0.2610998-0.72648,0.2605-1.0124102-0.0016003L6,13z M3.75,5.5c0-1.24264,1.00736-2.25,2.25-2.25 S8.25,4.25736,8.25,5.5S7.24264,7.75,6,7.75S3.75,6.74264,3.75,5.5z M6,4.75c-0.4142098,0-0.75,0.3357902-0.75,0.75 S5.5857902,6.25,6,6.25S6.75,5.9142098,6.75,5.5S6.4142098,4.75,6,4.75z",
    fill: "#73BE2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.bc3bfdba7c9d41d5b4e9a45edb77bf39.svg";
export { ForwardRef as ReactComponent };